import request from '@/utils/http'

const PREFIX = '/event'
// 自定事件
const event = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  show(eventId) {
    return request(
      `${PREFIX}/${eventId}`,
      'GET'
    )
  },

  eventAttributes(eventId) {
    return request(
      `${PREFIX}/${eventId}/attributes`,
      'GET'
    )
  },

  listTrigger(params) {
    return request(
      `${PREFIX}/list/trigger`,
      'post',
      params
    )
  },

  listByAppKey(appKey) {
    appKey = appKey === '' ? 'empty' : appKey
    return request(
      `${PREFIX}/list/${appKey}`,
      'GET'
    )
  },

  synchronize(id) {
    return request(
      `${PREFIX}/synchronize/${id}`,
      'get'
    )
  },

  synchronizeProgress(id) {
    return request(
      `${PREFIX}/synchronizeProgress/${id}`,
      'get'
    )
  },

  getLastSynchronizedTime(id) {
    return request(
      `${PREFIX}/synchronized/time/${id}`,
      'get'
    )
  },

  deleteBatchEvents(param) {
    return request(
      `${PREFIX}/delete`,
      'post',
      param
    )
  },

  reclaimEvent(params) {
    return request(
      `${PREFIX}/reclaim`,
      'post',
      params
    )
  },
  recoverEvent(params) {
    return request(
      `${PREFIX}/recover`,
      'post',
      params
    )
  }
}

export default event
